/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  getResultFromHistoryState
 */

import { AutocompleteResult } from '@zcode/bizos'
import type { Location } from 'history'

export const getResultFromHistoryState = ({ state }: Location<unknown>) => {
  if (
    typeof state === 'object' &&
    state &&
    'result' in state &&
    typeof state.result === 'object' &&
    state.result &&
    '_data' in state.result &&
    state.result._data &&
    typeof state.result._data === 'object' &&
    'record_type' in state.result._data &&
    typeof state.result._data.record_type === 'string'
  ) {
    // @ts-expect-error we didn't validate that _data has all the right properties
    return new AutocompleteResult(state.result._data)
  }
}
